import { render, staticRenderFns } from "./show.vue?vue&type=template&id=6faf2f98&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6faf2f98')) {
      api.createRecord('6faf2f98', component.options)
    } else {
      api.reload('6faf2f98', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=6faf2f98&", function () {
      api.rerender('6faf2f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/e-filling/show.vue"
export default component.exports